<div class="grid" style="margin-top: 8px;">
  <div class="col-12 lg:col-6">
    <div class="card main-height">
      <div class="card-header pt-1"><h4 class="mb-1">{{'misc.overview.templateInfo' | transloco}}</h4></div>
      <hr>
      <table class="details-table striped-table" *ngIf="template">
        <tr>
          <td class="p-3 bold">{{'attribute.uuid' | transloco}}</td>
          <td class="pr-1"><app-clipboard-label [value]="template.uuid" [copiedValue]="template.uuid"></app-clipboard-label></td>
        </tr>
        <tr>
          <td class="p-3 bold">{{'attribute.description' | transloco}}</td>
          <td *ngIf="template.description">{{template.description}}</td>
          <td *ngIf="!template.description" class="font-italic">{{'empty.description' | transloco}}</td>
        </tr>
        <tr>
          <td class="p-3 bold">{{'attribute.type' | transloco}}</td>
          <td *ngIf="template.type === 'DEVICE'">{{'model.device' | transloco}}</td>
          <td *ngIf="template.type === 'ASSET'" class="font-italic">{{'model.asset' | transloco}}</td>
        </tr>
        <tr *ngIf="'ROLE_SUPER_ADMIN' | userHasRole">
          <td class="p-3 bold">{{'model.tenant' | transloco}}</td>
          <td>
            <a *ngIf="template.tenant" [routerLink]="['/management/tenants', template.tenant.uuid, 'details']">
              {{template.tenant.name}}
            </a>
          </td>
        </tr>
        <tr>
          <td class="p-3 bold">{{'attribute.category' | transloco}}</td>
          <td *ngIf="template.deviceCategory">{{template.deviceCategory.name}}</td>
          <td *ngIf="!template.deviceCategory" class="font-italic">{{'empty.category' | transloco}}</td>
        </tr>
        <tr>
          <td class="p-3 bold">{{'attribute.createdAt' | transloco}}</td>
          <td>{{template.creationDate | customDate}}</td>
        </tr>
      </table>
      <app-table-skeleton *ngIf="!template" class="w-full" [rows]="3" height="200px" [striped]="true"></app-table-skeleton>
    </div>
  </div>
</div>
